<template>
  <article class="flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Тесты
    </h1>
    <CommonComplexFiltering
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :rubrics-list="rubrics?.data?.value"
      :sort-options="sortOptions"
      is-centuries-disabled
      :filters-active="filters"
    />
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedBaseCard
        v-for="test in tests?.data?.value?.data"
        :key="test.id"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        :data="test"
      >
        <template #badge
          ><span class="px-[32px] py-[8px] text-[12px]"
            >Вопросы: {{ test.questions }} Время: {{ test.time }} минут</span
          ></template
        >
      </MainPageCardsReworkedBaseCard>
    </div>

    <BaseThePagination :entity="tests" />

    <!-- <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="tests.hasNextPage.value"
        text="Показать еще"
        @click="tests.fetchNextPage()"
      />
    </div> -->
  </article>
</template>

<script setup>
const route = useRoute();
const router = useRouter();

const filters = computed(() => {
  return {
    sort_by: route.query?.sort_by,
    category: route.query?.category,
  };
});

const page = computed(() => Number(route.query?.page) || 1);

const { tests, resetPage } = useTests({ filters, per_page: 9, page });
const { rubrics } = useTestsCategories();

watch(filters, (newValue, prevValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(prevValue)) return;
  router.push({ query: { ...route.query, page: undefined } });
  resetPage(prevValue);
});

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

const sortOptions = [
  { id: 0, label: 'Свежие', value: '', icon: 'timer' },
  { id: 1, label: 'Популярные', value: 'views', icon: 'eye' },
  { id: 2, label: 'Любимые', value: 'likes', icon: 'like' },
];

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title(
    'История РФ: тесты для школьников и студентов | Пройти тест на Федеральном портале Истории России',
  ),
  meta: [
    {
      name: 'description',
      content:
        'История Российской Федерации в тестах. Освещаем все вехи российской истории в тестах. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>
